var render = function render(){var _vm=this,_c=_vm._self._c;return _c('marked',{staticClass:"markdown-container",attrs:{"sourceList":_vm.sourceList,"content":_vm.content}})
}
var staticRenderFns = []

export { render, staticRenderFns }